module.exports = __webpack_public_path__ + "img/DAY2-3.babcd437.jpg";